import avalanchecPlugin from '@exodus/avalanchec-plugin';
export const avalanchec = avalanchecPlugin;
